<template>
  <main class="mx-auto">
    <template v-if="isLoading">
      <div class="flex flex-col gap-6 py-36 px-5 container mx-auto">
        <UtilsSkeletonLoading class="w-full lg:w-3/4 h-36" />
        <UtilsSkeletonLoading class="w-[90%] lg:w-1/2 h-24" />
      </div>
    </template>
    <CommonBanner
      v-else
      :data="industriesBanner"
      :style="{
        'background-image': `url(${bgImage})`
      }"
      :half-width="true"
    />

    <WorkIndustry />
    <div class="container mx-auto">
      <WorkArticlesList
        header-text="Explore Our Expert Insights"
        :page-size="8"
      />
    </div>
  </main>
</template>

<script setup>
import { useGlobalStore } from '~/store/global'

const global = useGlobalStore()
const mainSeo = global.mainSeo

const isLoading = ref(true)
const route = useRoute()

const SEOMeta = ref({})
const industriesBanner = ref([])

const [banner, seo] = await Promise.all([
  useSuitmediaApiData('/api/banners', {
    query: {
      'filters[url]': '/industry',
      'fields[0]': 'id',
      'populate[banner][fields][0]': 'title',
      'populate[banner][fields][1]': 'description',
      'populate[banner][fields][2]': 'cta_wording',
      'populate[banner][fields][3]': 'cta_url',
      'populate[banner][populate][4]': 'image',
      'populate[banner][populate][5]': 'background_image'
    }
  }),
  useSuitmediaApiData('/api/seo-metas', {
    query: {
      'filters[url]': route.path,
      populate: 'seo.image'
    }
  })
])

isLoading.value = banner.pending.value

if (banner.error.value) {
  throw createError({
    statusCode: 404,
    message: `Case Studies does not exist`
  })
}

industriesBanner.value = banner.data.value.data[0]
SEOMeta.value = seo.data.value.data[0]

useJsonld({
  '@context': 'https://schema.org/',
  '@type': 'Organization',
  name: SEOMeta?.value?.attributes?.seo?.seo_title || 'Suitmedia',
  url: SEOMeta?.value?.attributes?.url || 'suitmedia.com',
  description:
    SEOMeta?.value?.attributes?.seo?.seo_description ||
    'Digital Agency Indonesia',
  image:
    SEOMeta?.value?.attributes?.seo?.image?.data?.attributes?.url ||
    industriesBanner.value?.attributes?.banner?.background_image?.data
      ?.attributes?.url ||
    mainSeo.attributes?.seo?.image?.data?.attributes?.url ||
    '/icon.png'
})

useSeoMeta({
  title: SEOMeta?.value?.attributes?.seo?.seo_title || 'Suitmedia',
  ogTitle: SEOMeta?.value?.attributes?.seo?.seo_title || 'Suitmedia',
  description:
    SEOMeta?.value?.attributes?.seo?.seo_description ||
    'Digital Agency Indonesia',
  ogDescription:
    SEOMeta?.value?.attributes?.seo?.seo_description ||
    'Digital Agency Indonesia',
  ogImage:
    SEOMeta?.value?.attributes?.seo?.image?.data?.attributes?.url ||
    industriesBanner.value?.attributes?.banner?.background_image?.data
      ?.attributes?.url ||
    mainSeo.attributes?.seo?.image?.data?.attributes?.url ||
    '/icon.png',
  ogType: SEOMeta?.value?.attributes?.seo?.open_graph_type,
  twitterTitle: SEOMeta?.value?.attributes?.seo?.seo_title || 'Suitmedia',
  twitterDescription:
    SEOMeta?.value?.attributes?.seo?.seo_description ||
    'Digital Agency Indonesia',
  twitterImage:
    SEOMeta?.value?.attributes?.seo?.image?.data?.attributes?.url ||
    industriesBanner.value?.attributes?.banner?.background_image?.data
      ?.attributes?.url ||
    mainSeo.attributes?.seo?.image?.data?.attributes?.url ||
    '/icon.png'
})

const bgImage = computed(() => {
  return industriesBanner.value?.attributes?.banner?.background_image?.data
    ?.attributes?.url
})
</script>

<style lang="scss" scoped></style>
